import displayRoutes from './routes'

/* @ngInject */
const displayRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(displayRoutes.index.path, {
      url: displayRoutes.index.url,
      controller: 'displayCtrl',
      template: require('./templates/index.html'),
    })
}

export default displayRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/display/display.routes.js